import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';

import { wacToken } from '@/libraries/design/foundations';

import { BitbucketFooterBottom } from './bitbucket-footer-bottom';
import { BitbucketFooterTop } from './bitbucket-footer-top';

const globalFooterStyle = css({
	alignItems: 'center',
	background: wacToken('color.neutral.light0'),
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
});

const globalFooterContentContainerStyle = css({
	backgroundColor: wacToken('color.neutral.light0'),
	paddingBlock: token('space.200'),
	display: 'flex',
	flexDirection: 'column',
	gap: token('space.200'),
	width: '100%',
	marginInline: '24px',

	[media.above.md]: {
		display: 'flex',
		maxWidth: '1200px',
		paddingInline: '0',
		marginInline: '60px',
	},
});

export const BitbucketFooter = () => (
	<footer css={globalFooterStyle}>
		<div css={[globalFooterContentContainerStyle]}>
			<BitbucketFooterTop />
			<BitbucketFooterBottom />
		</div>
	</footer>
);
